module.exports = __webpack_public_path__ + "static/img/4.555436f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/4.jpg
// module id = F+0k
// module chunks = 1